const CATEGORY_NAME_FIELD = "bvnmpzigqwuyexo7";
const CATEGORY_CODE_FIELD = "ije9picxiqzymy2s";
const PARENT_CODE_FIELD = "qhuaiawt9x0tnxte";
const PARENT_FIELD = "xktrqnhvq286zffq";

const firstParentId = (record) => {
  const parents = record && record[PARENT_FIELD];
  return Array.isArray(parents) && parents[0] ? parents[0].id : null;
};

const buildCategoryTree = (records) => {
  const source = Array.isArray(records) ? records : [];
  const nodes = source.map((record) => ({
    id: record.id,
    value: record[CATEGORY_NAME_FIELD],
    categoryCode: record[CATEGORY_CODE_FIELD],
    parentCode: record[PARENT_CODE_FIELD],
    parentId: firstParentId(record),
    children: [],
  }));
  const nodesById = {};
  const nodesByCode = {};
  const roots = [];

  nodes.forEach((node) => {
    nodesById[node.id] = node;
    if (node.categoryCode !== null && node.categoryCode !== undefined) {
      nodesByCode[node.categoryCode] = node;
    }
  });

  nodes.forEach((node) => {
    const parent = nodesById[node.parentId] || nodesByCode[node.parentCode];
    if (parent && parent !== node) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
};

module.exports = {
  buildCategoryTree,
};



// WEBPACK FOOTER //
// ./src/util/categoryTree.js